import Dashboard from 'records/Dashboard';
import Base from 'records/Base';

import {
  DASHBOARD_META_DESIGNS_ASYNC_ACTION_SUCCESS,
  DASHBOARD_META_MENUS_ASYNC_ACTION_SUCCESS,
  DASHBOARD_META_RECIPES_ASYNC_ACTION_SUCCESS,
  DASHBOARD_META_RESET_STATE,
} from 'actions/dashboard';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Dashboard(),
});

const actionsMap = {
  [DASHBOARD_META_DESIGNS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const designs = action.data.count;
    let dashboardData = state.data;
    dashboardData = dashboardData.set('designs', designs);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: dashboardData,
    });
  },
  [DASHBOARD_META_MENUS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const menus = action.data.count;
    let dashboardData = state.data;
    dashboardData = dashboardData.set('menus', menus);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: dashboardData,
    });
  },
  [DASHBOARD_META_RECIPES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const recipes = action.data.count;
    let dashboardData = state.data;
    dashboardData = dashboardData.set('recipes', recipes);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: dashboardData,
    });
  },
  [DASHBOARD_META_RESET_STATE]: () => {
    return initialState;
  },
};

export default function dashboard(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
